import React, { useState } from "react";
import CustomDropdown from "../../common/CustomDropdown";
import { FaFileExcel } from "react-icons/fa";
import LoanBuySwitch from "../../common/LoanBuySwitch";
import ViewModeToggle from "../../common/ViewModeToggle";

const AgentTendersMobileTabs = ({
  activeTab,
  onTabChange,
  onFilterClick,
  sortBy,
  handleSortChange,
  searchTerm,
  handleSearchChange,
  onSubTabChange,
  activeSubTab,
  activePositionFilter,
  handlePositionFilterChange,
  pitchStatus,
  onPitchStatusChange,
  onExport,
  exporting,
  exportDisabled,
  typeOfTender,
  onTypeOfTenderChange,
  viewMode,
  onViewModeChange,
}) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const handleSearchIconClick = () => {
    setIsSearchVisible(true);
  };

  const handleCloseSearch = () => {
    setIsSearchVisible(false);
  };

  const tabs = [
    { id: "all", label: "All Listed Requests" },
    { id: "applied", label: "Applied pitches" },
    { id: "saved", label: "Saved" },
  ];

  if (isSearchVisible) {
    return (
      <div className="px-4 py-3 bg-white flex items-center gap-2 border-y border-[#0000001A]">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 9.5L7.325 7.325M8.5 4.5C8.5 6.70914 6.70914 8.5 4.5 8.5C2.29086 8.5 0.5 6.70914 0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5C6.70914 0.5 8.5 2.29086 8.5 4.5Z"
                stroke="#1A212F"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search by position or club name"
            value={searchTerm}
            onChange={(e) => handleSearchChange(e.target.value)}
            className="w-full pl-8 pr-4 py-2 border border-[#E6E6E6] placeholder:text-sm placeholder:text-[#1E1E1E] rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
            autoFocus
          />
        </div>
        <button
          onClick={handleCloseSearch}
          className="p-2"
          aria-label="Close search"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#1A212F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="px-4 bg-white flex justify-between items-center border-y border-[#0000001A] overflow-x-auto">
        <div className="flex items-center gap-4">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`py-4 text-xs whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                  : "text-[#1E1E1ECC]"
              }`}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>

      <div className="px-4 py-3 bg-white flex justify-end items-center border-b border-[#0000001A]">
        <div className="flex items-center gap-2">
          {/* Icon-only controls: a real <button> with an aria-label, like the
              "Close search" button in the search state above. As bare
              <div onClick> they were unreachable by keyboard, announced as
              nothing by a screen reader, and — being icon-only — had no
              accessible name at all. */}
          <button
            type="button"
            aria-label="Search requests"
            className="p-3 bg-[#F7F7F7] rounded-lg"
            onClick={handleSearchIconClick}
          >
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 9.5L7.325 7.325M8.5 4.5C8.5 6.70914 6.70914 8.5 4.5 8.5C2.29086 8.5 0.5 6.70914 0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5C6.70914 0.5 8.5 2.29086 8.5 4.5Z"
                stroke="#1A212F"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {activeTab === "applied" ? (
            <>
              <div className="text-xs">
                <CustomDropdown
                  options={[
                    { value: "all", label: "All Status" },
                    { value: "pitch_sent", label: "Pitch Sent" },
                    { value: "accepted", label: "Accepted" },
                    { value: "rejected", label: "Rejected" },
                  ]}
                  value={pitchStatus}
                  onChange={onPitchStatusChange}
                  placeholder="All Status"
                  className="flex items-center gap-2 p-3 bg-[#E9F3FF] text-[#2283FF] rounded-lg font-medium"
                />
              </div>
              <button
                onClick={onExport}
                disabled={exporting || exportDisabled}
                className="p-3 bg-[#F7F7F7] rounded-lg disabled:opacity-50"
              >
                <FaFileExcel />
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                aria-label="Filter requests"
                className="p-3 bg-[#F7F7F7] rounded-lg"
                onClick={onFilterClick}
              >
                <svg
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 0.5H1L5 5.23V8.5L7 9.5V5.23L11 0.5Z"
                    stroke="#1A212F"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="text-xs">
                <CustomDropdown
                  options={[
                    { value: "pro", label: "Pro" },
                    { value: "youth", label: "Youth" },
                  ]}
                  value={sortBy}
                  onChange={handleSortChange}
                  placeholder="Pro"
                  className="flex items-center gap-2 p-3 bg-[#E9F3FF] text-[#2283FF] rounded-lg font-medium"
                />
              </div>
            </>
          )}
        </div>
      </div>

      {activeTab === "all" && (
        <div className="px-4 bg-white flex justify-between items-center border-b border-[#0000001A]">
          <div className="flex items-center gap-4">
            <div
              onClick={() => onSubTabChange("tp-tenders")}
              className={`py-4 text-xs cursor-pointer ${
                activeSubTab === "tp-tenders"
                  ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                  : "text-[#1E1E1ECC]"
              }`}
            >
              TP Requests
            </div>
            <div
              onClick={() => onSubTabChange("tp-lite-tenders")}
              className={`py-4 text-xs cursor-pointer ${
                activeSubTab === "tp-lite-tenders"
                  ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                  : "text-[#1E1E1ECC]"
              }`}
            >
              TP Lite Requests
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-xs">
              <CustomDropdown
                options={[
                  { value: "players", label: "Players" },
                  { value: "coaches", label: "Coaches" },
                  { value: "staffs", label: "Staffs" },
                  // Agency/agent intentionally has NO "Others" (Marin);
                  // "Others" stays club-only. Mirrors the desktop TenderTabs
                  // isFromAgent branch (Players/Coaches/Staffs).
                ]}
                value={activePositionFilter}
                onChange={handlePositionFilterChange}
                placeholder="Players"
                className="flex items-center gap-2 p-3 bg-[#E9F3FF] text-[#2283FF] rounded-lg "
              />
            </div>
          </div>
        </div>
      )}

      {/* Mobile controls row: Buy/Loan switch + Cards/List toggle, on their
          own line so they're usable and don't crowd the tabs. */}
      {activeTab === "all" && onTypeOfTenderChange && (
        <div className="px-4 py-3 bg-white flex items-center justify-between gap-3 border-b border-[#0000001A] overflow-x-auto">
          <LoanBuySwitch value={typeOfTender} onChange={onTypeOfTenderChange} />
          {onViewModeChange && (
            <ViewModeToggle value={viewMode} onChange={onViewModeChange} />
          )}
        </div>
      )}
    </>
  );
};

export default AgentTendersMobileTabs;